import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { connectDefault } from '../utils/utils'

export class Portal extends Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    adminBaseUrl: PropTypes.string.isRequired,
    ahBaseUrl: PropTypes.string.isRequired,
    appId: PropTypes.string,
    channelType: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  }

  render(){
    let children = null;
    const { account, adminBaseUrl, ahBaseUrl, appId, channelType, dispatch } = this.props
    if (account.fulfilled) {
      const accountId = account.value.id
      children = React.cloneElement(this.props.children, {
          ahBaseUrl: ahBaseUrl,
          accountBaseURL: `${adminBaseUrl}/accounts/${accountId}`,
          appId: appId,
          channelType: channelType,
          dispatch: dispatch
      })
    }
    return (
      <div>
        {children}
      </div>
    );
  }
}

export default connect.defaults(connectDefault)(props => {
    return {
      account: {
        title: 'Fetch Accounts',
        url:`${props.adminBaseUrl}/accounts/`,
        dispatch: props.dispatch,
        then: (accounts) => ({
          value: accounts[0]
        })
      }
    }
  })(Portal)



// WEBPACK FOOTER //
// ./src/containers/Portal.js